/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Date_OverdueInputs */

const en_date_overdue = /** @type {(inputs: Date_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`overdue`)
};

const de_date_overdue = /** @type {(inputs: Date_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`überfällig`)
};

/**
* | output |
* | --- |
* | "overdue" |
*
* @param {Date_OverdueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const date_overdue = /** @type {((inputs?: Date_OverdueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Date_OverdueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_date_overdue(inputs)
	return en_date_overdue(inputs)
});